export default {
    paymentMethodId: "",
    institutionNumber: "",
    accountNumber: null,
    transitNumber: null,
}
